import { Component, OnInit, Input } from '@angular/core';
import { AgregarPuntoComponent } from '../agregar-punto/agregar-punto.component';
import { MatDialog } from '@angular/material/dialog';
import { Gtp } from 'src/app/shared/gtp';
import Swal from 'sweetalert2'
import { PuntosService } from 'src/app/shared/services/puntos-service/puntos.service';
//import { ToolsPuntosClienteComponent } from '../../mapa-tools-pop/tools-puntoscliente/tools-puntoscliente.component';

@Component({
  selector: 'app-mapa-infowindow-puntocliente',
  templateUrl: './mapa-infowindow-puntocliente.component.html',
  styleUrls: ['./mapa-infowindow-puntocliente.component.scss']
})
export class MapaInfowindowPuntoClienteComponent implements OnInit {

  @Input() 
  punto: any;
  public showTabs:any = false;
  public tipoDePlan:any = '';
  public nombre = '';

  constructor(
    public dialog: MatDialog,
    private gtp: Gtp,
    public puntosService: PuntosService,
    //public toolpuntocliente:ToolsPuntosClienteComponent
  ) {
    let user = JSON.parse(this.gtp.getUserData());
    this.tipoDePlan = (user.cliente_plan_id == 1) ? "planBasico" : "planFull";
  }

  ngOnInit() {

    //console.log(this.punto);
    if (this.punto.eventos || this.punto.puntoscercanos){
      this.showTabs = true;
    }
  }

  popAddPunto(){
    this.punto.openinfo = false
    this.dialog.open(AgregarPuntoComponent, {
      minWidth: 700,
      data: {
        latitud: this.punto.latitud,
        longitud: this.punto.longitud,
      }
    });
  }


  popEliminarPunto(){
    this.punto.openinfo = false
    Swal.fire({
      title: 'Atención!, Esta Seguro de Eliminar?',
      text: 'ID: '+ this.punto.gid+ ' Descripción: '+ this.punto.nombre,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, Borrar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.puntosService.deletePunto(this.punto.gid).subscribe(res => {
          console.log(res)
          if (res) {
            //let newlist = [];
            this.puntosService.setPuntosClienteObs( []); 
            Swal.fire(
              'Buen Trabajo!',
              'El punto fue eliminado correctamente',
              'success'
            )
            //this.toolpuntocliente.getGrupoPuntos()
           // this.toolpuntocliente.showAllHidePuntos(true)
          } else {
            Swal.fire(
              'Epa..!',
              'Ocurrio un error en el proceso',
              'error'
            )
          }

        }, function(error){
          Swal.fire(
            'Epa..!',
            error,
            'error'
          )
        });
      }
    })
  }

}